import { CategoryService } from "core/service";
import { CategoryPersistence } from "core/persistence";
import { Category } from "core/entity";
import { RuntimeRepository } from "core/repository";
import BaseRepository from "./base.repository";

class CategoryRepository extends BaseRepository {
  syncable = false;

  getEntityIdentifier() {
    return "category";
  }

  resourceName() {
    return "categorias";
  }

  getPersistenceProvider() {
    return CategoryPersistence;
  }

  getServiceProvider() {
    return CategoryService;
  }

  async modelToEntity(model) {
    const entity = new Category(model);

    if (entity.category_uuid) {
      this.get(entity.category_uuid).then(categoryResult => {
        if (categoryResult.success) {
          entity.category = categoryResult.data;
        }
      });
    }

    return entity;
  }

  async disable(uuid, action) {
    const currentUser = await this.mRuntime.get(
      RuntimeRepository.props.currentUser
    );
    const result = await this.mService.delete(currentUser.company_uuid, uuid, {
      children: action
    });

    if (result.success) {
      this.mRuntime.fire(`category/delete`, uuid);
    }

    return result;
  }

  async searchByName(name) {
    const currentUser = await this.mRuntime.get(
      RuntimeRepository.props.currentUser
    );
    const filters = [
      { field: "deleted", operation: "EQ", value: false },
      { field: "name", operation: "LIKE", value: name },
      {
        field: "company_uuid",
        operation: "EQ",
        value: currentUser.company_uuid
      }
    ];

    const categories = [];
    const success = await this.mPersistence.stream(filters, category =>
      categories.push(category)
    );

    return success ? { success, data: categories } : { success };
  }

  async getCategories({ order = [], pagination = {}, filters = [] }) {
    const currentUser = await this.mRuntime.get(
      RuntimeRepository.props.currentUser
    );
    const serviceResult = await this.mService.fetch(currentUser.company_uuid, {
      order,
      pagination,
      filters
    });

    if (serviceResult.success) {
      return {
        success: true,
        results: serviceResult.data,
        total: serviceResult.headers["total"],
        perPage: serviceResult.headers["per-page"]
      };
    }

    return {
      success: false,
      fatal: serviceResult.fatal,
      errors: serviceResult.errors
    };
  }

  async getExistingCategory(companyUuid, categoryUuid) {
    return this.mService.fetchByUuid(companyUuid, categoryUuid);
  }

  async updateCategory(companyUuid, categoryUuid, params) {
    return this.mService.updateCategory(companyUuid, categoryUuid, params);
  }

  async createCategory(companyUuid, params) {
    return this.mService.createCategory(companyUuid, params);
  }

  async deleteCategory(companyUuid, categoryUuid) {
    return this.mService.deleteCategory(companyUuid, categoryUuid);
  }
}

export default new CategoryRepository();



// WEBPACK FOOTER //
// ./src/core/repository/category.repository.js